"use client"
import { debounce } from "@mui/material/utils"

/**
 * Preprocesses query to handle special characters for exact matching
 */
const preprocessQuery = (query: string): string => {
  // If query contains any special characters, wrap in quotes for exact matching
  return /[^a-zA-Z0-9/\s]/.test(query) ? `"${query}"` : query
}

/**
 * client side debounce function for typesense search
 */
export const debounceQueryHook = debounce(
  (query: string, search: (query: string) => void) => {
    search(query)
  },
  300,
)

/**
 * Debounce hook with exact matching for special characters (for transfers)
 */
export const debounceQueryHookWithExactMatch = debounce(
  (query: string, search: (query: string) => void) => {
    search(preprocessQuery(query))
  },
  300,
)
